<ng-container *transloco="let t"
  ><div class="instruction-form">
    <form [formGroup]="form">
      <mat-card appearance="outlined" [formGroupName]="'instructionInfo'">
        <mat-card-content>
          <h3>{{ t('Request for examination') }}</h3>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Establish') }}</mat-label>
            <input appAutofocus matInput formControlName="institution" />
            @if (
              form
                .get(['instructionInfo', 'institution'])
                ?.hasError('required') &&
              (form.get(['instructionInfo', 'institution'])?.touched ||
                form.get(['instructionInfo', 'institution'])?.dirty)
            ) {
              <mat-error>
                {{ t('This field is required') }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{
              t('Medical history and clinical findings')
            }}</mat-label>
            <textarea
              matInput
              rows="5"
              formControlName="medicalHistory"
            ></textarea>
            @if (
              form
                .get(['instructionInfo', 'medicalHistory'])
                ?.hasError('required') &&
              (form.get(['instructionInfo', 'medicalHistory'])?.touched ||
                form.get(['instructionInfo', 'medicalHistory'])?.dirty)
            ) {
              <mat-error>
                {{ t('This field is required') }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{
              t('Please perform the following examination')
            }}</mat-label>
            <textarea
              matInput
              rows="5"
              formControlName="requestedExamination"
            ></textarea>
            @if (
              form
                .get(['instructionInfo', 'requestedExamination'])
                ?.hasError('required') &&
              (form.get(['instructionInfo', 'requestedExamination'])?.touched ||
                form.get(['instructionInfo', 'requestedExamination'])?.dirty)
            ) {
              <mat-error>
                {{ t('This field is required') }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Note') }}</mat-label>
            <textarea matInput rows="3" formControlName="note"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ t('Veterinarian name and surname') }}</mat-label>
            <input matInput formControlName="veterinarianName" />
            <mat-error>{{ t('This field is required') }}</mat-error>
          </mat-form-field>
        </mat-card-content>

        <!-- Save is handled by the dialog confirm button -->
      </mat-card>
    </form>
  </div>
</ng-container>
